// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZQgO","title":"styles_title__2eOjL"};